import React, { memo, FC } from 'react';
import { NavItem as Component, NavItemProps } from './styled';

export const NavItem: FC<NavItemProps> = memo((props) => (
  <Component {...props} />
));
